// extracted by mini-css-extract-plugin
module.exports = {"receiptLink":"styles_receiptLink__3afmX","status":"styles_status__3RXyM","typeBadge":"styles_typeBadge__36qyk","typeBadgeDot":"styles_typeBadgeDot__1wboX"};